<template>
  <div
    :class="info"
    class="info-content">
    <button @click="$emit('close-info')" class="close" aria-label="close">
      <img role="button" src="@/assets/img/icon-close-white.svg" alt="Go back" width="16.72px" height="16.72px">
    </button>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'info-content',
  props: {
    selectedInfo: String,
    info: String,
  }
};
</script>

<style lang="scss" scoped>
@import '~@/scss/styles.scss';

.info-content {
  margin-left: 67px;
  margin-top: 16px;
  background-color: rgba(2, 55, 97, .9);
  color: $white;
  padding: 30px 37px 20px 20px;
  min-height: 270px;
  position: relative;

  // &.secondary {
  //   width: 312.67px;
  //   margin-left: auto;
  //   @include breakpoint(md) {
  //     width: calc(100% - 116px);
  //   }
  //   @include breakpoint(sm) {
  //     width: calc(100% - 88px);
  //   }
  //   @include breakpoint(xs) {
  //     width: calc(100% - 88px);
  //   }
  // }

  @include breakpoint(xs) {
    margin-left: 0;
  }

  @include breakpoint(sm) {
    margin-left: 0;
  }

  @include breakpoint(md) {
    margin-left: 0;
    width: 100%;
  }

  h2 {
    font-size: rem(18px);
    line-height: rem(24px);
    font-weight: $font-weight-bold;
    margin-bottom: 16px;
    width: 100%;
  }

  p {
    font-size: rem(15px);
    line-height: rem(20px);
    margin-bottom: 10px;
  }

  ul {
    padding-left: 20px;

    li {
      font-size: rem(15px);
      line-height: rem(20px);
      margin-bottom: 10px;
    }
  }

  &.brain {
    .btn-pathways {
      border: 2px solid $white;
      padding: 0 20px;
      background-color: transparent;
      width: 285px;
      height: 57px;
      justify-content: space-between;
      color: $white;
      font-size: rem(20px);
      position: absolute;
      bottom: 20px;
      left: 50%;
      transform: translateX(-50%);
    }

    @include breakpoint(sm) {
      padding: 20px;

      p {
        padding-right: 37px;
      }
    }
    @include breakpoint(md) {
      padding: 20px;

      p {
        padding-right: 37px;
      }
    }
  }

  @include breakpoint(sm) {
    &.eia {
      padding: 35px 20px 20px;

      ::v-deep .video-thumb {
        width: 100% !important;
      }
    }
  }
}

.close {
  position: absolute;
  top: 20px;
  right: 20px;
  padding: 0;
  border: none;
  background: none;

  @include breakpoint(sm) {
    top: 10px;
    right: 10px;
  }
}
</style>
